(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-beauty-bundles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('[data-bundle-status]');
      var items = Array.from(form.querySelectorAll('[data-bundle-variant]')).map(function (field) {
        return { id: Number(field.value), quantity: 1 };
      }).filter(function (item) { return item.id; });

      if (!items.length) return;

      button.disabled = true;
      status.textContent = 'Legger pakken i handlekurven …';
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart-add-failed');
        return response.json();
      }).then(function () {
        window.location.href = theme.routes.cartPage;
      }).catch(function () {
        status.textContent = 'Noe gikk galt. Prøv igjen.';
        button.disabled = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || !window.theme || !window.theme.AjaxProduct) return;

      root.querySelectorAll('[data-bestseller-cart-form]').forEach((form) => {
        if (form.dataset.ajaxInitialized === 'true') return;
        form.dataset.ajaxInitialized = 'true';
        new window.theme.AjaxProduct(form, '.bt-bestseller-card__button');
      });
    };

    const initializeAll = () => initialize(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordic-glow-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.btNordicGlowBundleInitialized) return;
    window.btNordicGlowBundleInitialized = true;

    function formatPrice(cents, form) {
      var currency = form.dataset.currencyCode || 'NOK';
      return new Intl.NumberFormat('nb-NO', { style: 'currency', currency: currency }).format(cents / 100);
    }

    function updateBundlePrice(form) {
      var cleanserPrice = Number(form.dataset.cleanserPrice);
      var ledPrice = Number(form.dataset.ledPrice);
      var shadeSelect = form.querySelector('[data-nordic-glow-shade]');
      var selectedShade = shadeSelect && shadeSelect.selectedOptions[0];
      var ccPrice = selectedShade ? Number(selectedShade.dataset.price) : 0;
      var percent = Number(form.dataset.discountPercent) || 20;
      var total = cleanserPrice + ledPrice + ccPrice;
      var discounted = Math.round(total * (100 - percent) / 100);
      var savings = total - discounted;
      var regularPrice = form.querySelector('[data-nordic-glow-regular-price]');
      var discountedPrice = form.querySelector('[data-nordic-glow-discounted-price]');
      var savingsAmount = form.querySelector('[data-nordic-glow-savings-amount]');
      var ccItemPrice = form.querySelector('[data-nordic-glow-cc-price]');
      var shipping = form.querySelector('[data-nordic-glow-shipping]');
      var threshold = Number(form.dataset.freeShippingThreshold);

      if (regularPrice) regularPrice.textContent = formatPrice(total, form);
      if (discountedPrice) discountedPrice.textContent = formatPrice(discounted, form);
      if (savingsAmount) savingsAmount.textContent = formatPrice(savings, form);
      if (ccItemPrice && selectedShade) ccItemPrice.textContent = formatPrice(ccPrice, form);
      if (shipping) {
        shipping.textContent = discounted >= threshold
          ? 'Fri frakt inkludert'
          : 'Fri frakt på ordre over ' + formatPrice(threshold, form);
      }
    }

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-nordic-glow-shade]')) return;
      var form = event.target.closest('[data-nordic-glow-form]');
      if (form) updateBundlePrice(form);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-nordic-glow-form]');
      if (!form) return;

      event.preventDefault();
      var button = form.querySelector('[data-nordic-glow-submit]');
      var status = form.querySelector('[data-nordic-glow-status]');
      var items = Array.prototype.map.call(form.querySelectorAll('[data-nordic-glow-item], [data-nordic-glow-shade]'), function (field) {
        return { id: Number(field.value), quantity: 1 };
      }).filter(function (item) { return item.id; });

      if (!button || items.length !== 3) {
        if (status) status.textContent = 'Velg en tilgjengelig nyanse og prøv igjen.';
        return;
      }

      button.disabled = true;
      if (status) status.textContent = 'Legger pakken i handlekurven …';

      fetch(form.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error('cart-add-failed');
          return data;
        });
      }).then(function () {
        window.location.assign(form.dataset.cartUrl);
      }).catch(function () {
        if (status) status.textContent = 'Pakken kunne ikke legges i handlekurven. Kontroller lagerstatus og prøv igjen.';
        button.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
